module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ch02"
    }
  }, [_c('a', {
    attrs: {
      "id": "page30"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterNumber",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Chapter Two")])])])])]), _c('div', {
    staticClass: "chapterBody"
  }, [_c('a', {
    attrs: {
      "id": "page30"
    }
  }, [_c('p', {
    staticClass: "chapterOpenerText",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "chapterOpenerFirstLetters"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("T")])]), _vm._v("o her father’s question of why she had been so ill-disposed towards Sir Nicholas Rayne that afternoon, Adorna had no convincing reply except that she didn’t much care for the man.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Sir Thomas agreed that the excuse was a poor one. ‘I hope I’m not as short with those I don’t much care for, my lass, or I’d not hold on to my office for too long. Is there more to it than that?’ He was a shrewd man, tall and elegant with white hair and beard and a reputation for fairness that made him keep friends with all factions.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘No, Father. No more than that.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘He’s a well set-up fellow. The earl speaks highly of him.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Yes, Father. I expect Cousin Hester will like him well enough, too.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Then perhaps by that time you could pretend to, for everyone’s sake.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Yes, Father. I’m sorry.’")])]), _c('a', {
    attrs: {
      "id": "page31"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘He has more about him than Master Fowler, for all his long title.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Oh, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Father")]), _vm._v("!’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Well, you’re twenty now, Adorna, and you can’t be chasing them off for ever, you know. There are several who—’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘No…no, Father, I beg you will do no such thing. I shall know the man I want when I see him, and Peter will serve quite well until then.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Really? Well then, you’d better start looking a bit harder because it’s time your mother and I were grandparents. Perhaps you’re being a bit too pernickety, my dear, eh?’ He touched her chin gently with one fingertip.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Yes, Father. I expect I probably am.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Pernickety was perhaps not the word Adorna would have applied to her thoughts on men and marriage, though she might have agreed that they were somewhat idealised. Having never been in love, she had relied so far on the descriptions given her by friends and those gleaned from romantic tales of King Arthur and Greek mythology. Not the most reliable of sources, but all there were available. Consequently, she believed she would recognise it when it happened, that she would know the man when he appeared. Obnoxious, arrogant and presumptuous men were not on her list of requirements. For all that, she could not have said why, if he were so very unsuitable, Sir Nicholas Rayne was continually on her mind, or why his face and form were before her in the minutest detail.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page31"
    }
  }, [_vm._v("To her amusement, she had heard in the usual ")]), _c('a', {
    attrs: {
      "id": "page32"
    }
  }, [_vm._v("roundabout manner that she was regarded by some men as being hard to get, not only because of her efficient safety nets, but mainly because she had never yet been prepared to bind herself to any man’s exclusive friendship for more than a few weeks. There were men and women among her friends whom she had known as a child, some of whom were parents by now, but she and a few others enjoyed their state of relative freedom too much to let go of it. In the same way, she supposed, that the Queen enjoyed hers. While others involved themselves deeply in the serious business of mate-finding and binding, she was happy to indulge in men’s admiration from a distance, sometimes playing one off against the other, but committing herself to none. It was a harmless and delicious game to play in which she took control, rather like the plays her brother wrote where actors acted out a story and then removed the disguise and went home to sleep soundly.")])]), _c('a', {
    attrs: {
      "id": "page32"
    }
  }), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page32"
    }
  }, [_vm._v("She found her father’s sudden concern irritating. It suggested to her that he might cease to be as helpful to her as he had been in the past. It also suggested that he had recognised in Sir Nicholas Rayne a man he might be prepared to consider as son-in-law if she didn’t make it absolutely clear that he was not the man she was looking for. Exactly who she "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("was")]), _vm._v(" looking for would be harder to explain, for while she and her female friends accepted their own conquettish ways as being perfectly normal, none of them felt that fickleness in a man was desirable. A man must be constant, adoring and lover-like, and none of those commend")]), _c('a', {
    attrs: {
      "id": "page33"
    }
  }, [_vm._v("able traits could be ascribed to Sir Nicholas Rayne, Deputy Master of Horse. Let him stick to his horses and she would stick to her ideals.")])]), _c('a', {
    attrs: {
      "id": "page33"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Sheen House was the most convenient of the Pickerings’ houses, the nearest to Sir Thomas’s place of work when the Queen was in residence. It was also Adorna’s favourite, situated to one side of the old friary built by the Queen’s grandfather when he rebuilt the old palace of Sheen, which had been destroyed by fire. Sheen Palace in its new form was then renamed Richmond after the earldom in North Yorkshire that had been Henry VII’s favourite home. The palace was massively built on the edge of the River Thames, its gardens enclosing the friary which had its own private garden, known as the paradise, at the eastern end. Since the dissolution of the monasteries almost forty years previously, the friary had been left to disintegrate, its stone reused, its beautiful paradise overgrown, now used by the palace guests for walking in private. The road that led past Sheen House, past the old friary and down the southern wall of the palace garden to the river, had now become Paradise Road. Most of the friary land was visible from the garden of Sir Thomas Pickering’s house, providing what appeared to be an extension of their own, the friary orchard and vineyard being used by the palace gardeners. The rest of Richmond’s houses spread along the riverbank to the south, most of them timber-framed set amidst spacious gardens and orchards, free from the noise and foul air of London Town.")])]), _c('a', {
    attrs: {
      "id": "page34"
    }
  }, [_c('p', {
    staticClass: "spaceBreak",
    staticStyle: {
      "text-indent": "0%"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Sheen House, however, was built of soft pink brick like the palace itself, originally in the shape of an E for Elizabeth. Sir Thomas’s latest addition to the buildings was a banqueting house in the garden, built especially for Lady Marion’s entertaining, and it was here on the next day that the call reached Adorna and Maybelle that Cousin Hester had arrived. The small octagonal room was situated in one corner approached by a paved walkway above the fountain-garden, far enough from the house for them to remove their aprons and fling them on to the steps before greeting their guest.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("They had fully expected to see some change in Cousin Hester, having last seen her as a mere child of ten on one of her father’s rare visits to Sheen House. Hester’s father had never been married, not even to Hester’s mother, an unknown lady of the Court who had allowed her daughter to be brought up by one of Sir William’s married sisters. Consequently, the astonishment felt by both women at the sight of each other was in Adorna’s case cleverly concealed, and in Hester’s case not so.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Oh!’ she whispered. ‘Oh…I…er…Mistress Adorna?’ Hester looked from Adorna to Maybelle and back again. Although a year older than her cousin, she was still painfully shy, twisting her black kid gloves together like a dish-clout, her eyes wide and fearful.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page34"
    }
  }, [_vm._v("Bemused, Lady Marion laid a motherly arm across her guest’s shoulders. ‘Call her Adorna,’ she whispered, kindly. ‘And for all you’re Sir Thomas’s cousin rather than our children’s, you must call us all by our ")]), _c('a', {
    attrs: {
      "id": "page35"
    }
  }, [_vm._v("Christian names, you know. Sir Thomas and Seton and Adrian will be in later.’")])]), _c('a', {
    attrs: {
      "id": "page35"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("That announcement did not provoke the delighted anticipation it was intended to, for the young lady looked as if she might have preferred to make a bolt for it rather than meet men and boys.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Adorna took pity on her, smiling with hands outstretched. The wringing hands did not respond. ‘Welcome, Cousin Hester. You must be tired after your journey from St Andrews-Underhill.’ There was no real reason why she should have been, for her new home was only a stone’s throw from St Paul’s in the centre of London.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Yes,’ Hester whispered. She looked around her at the white plasterwork and the warm tapestried walls. ‘It’s cool and quiet here. I remember how I liked it before, long ago.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Well,’ Lady Marion said, leading her towards the carved oak staircase, ‘a lot’s happened since then, and now you’re a woman of independent means, free to do whatever you wish. You’re our guest for as long as you choose to stay.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("There was no corresponding flash of delight at hearing her new status described. On the contrary, the very idea of having to make her own decisions was apparently not something she looked forward to with any relish. Sir William Pickering, Sir Thomas’s cousin, had died at the beginning of the year, leaving his fortune and his house in London to Hester.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page35"
    }
  }, [_vm._v("‘Did you bring your maid with you?’ said Adorna. ‘If not, you shall share Maybelle with me. She knows ")]), _c('a', {
    attrs: {
      "id": "page36"
    }
  }, [_vm._v("how to dress hair in the latest fashions. Come, shall we find your room? The men will bring your baggage up.’")])]), _c('a', {
    attrs: {
      "id": "page36"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Cousin Hester’s mourning-garb was only to be expected, in the circumstances, though neither the hostess nor her daughter would have allowed themselves to look quite so dowdy as their guest had the same thing happened to them. While they were not particularly in the forefront of fashion as those at Court were, neither were they ten years behind it as Hester was. Her figure could only be guessed at, concealed beneath a loose-bodied gown closed from neck to hem with fur-edged ties, puffed shoulder-sleeves and tight bead-covered under-sleeves. The hair to which Maybelle may or may not have access was almost completely hidden beneath a black french hood that hung well down at the back, though the bit of hair that showed at the front was brownish and looked, Maybelle thought, as if it needed a washing before it would reveal its true colour.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page36"
    }
  }, [_vm._v("After her father’s reproach the day before, Adorna now exercised all her charity towards her half-cousin, knowing little of the background of experience which had kept Hester inside her protective shell. For a woman of her age, she was impossibly tongue-tied and, for an heiress, she was going to find it difficult to protect herself from fortune-seeking men of whom there were countless hereabouts. Adorna managed it by virtue of her closeness to her parents; Hester would not manage it at all without some help. Yet on their guest list for Saturday, Adorna and her mother had ")]), _c('a', {
    attrs: {
      "id": "page37"
    }
  }, [_vm._v("already paired off this pathetic young lady with Sir Nicholas Rayne who might, for all they knew, be one of those sharks from whom she would need protection. On the other hand, they might suit each other perfectly. Strangely, the idea had lost its appeal for Adorna.")])]), _c('a', {
    attrs: {
      "id": "page37"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Having helped to unpack Hester’s rather inadequate belongings and a very limited range of clothes, Adorna conducted her on a tour of the house, which she believed would make her feel more at home. Inside, there was much of it that Hester remembered, but outside, the large formal garden had been restructured into a series of smaller ones bounded by tall hedges, walls, trellises and stone balustrades, walkways, steps and spreading trees. The banqueting house was also new to her.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Adorna opened the double doors to reveal a marble-floored garden-room with windows on all eight of its sides. The ceiling was prettily plastered with clouds and cherubs bearing fruit, and the panels between the windows were painted to represent views of the garden beyond. In the centre of the floor was a round marble table supported by grimacing cherubs.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘For the banquets,’ Adorna said, ‘the suckets and marchpanes. I’m making them ready in the stillroom. We’ll come out here after the last course and nibble while the servants clear the hall ready for the entertainment.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Tonight?’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘No, tomorrow. About thirty guests are coming to dinner. Didn’t Mother tell you?’")])]), _c('a', {
    attrs: {
      "id": "page38"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The colour drained from Hester’s face. ‘Guests? Oh, dear.’ Her hand flew to her mouth. ‘Perhaps I should stay in my room. I’m in mourning, you must remember.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Hester, dear…’ Adorna drew her down to a stone bench fixed to the wall ‘…being in mourning doesn’t mean you have to avoid people. It’s nearly seven months since Sir William died, and how often did you see him in your twenty-one years?’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Two…three times. I don’t recall.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘So, you can still wear black for a full year, if you wish, but Sir William would not have wanted you to hide away for so long, would he? After all, he was a man who lived life to the full, I believe.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She supposed Hester to know at least as much as she did about Sir William Pickering, who had once believed himself to be in the running for the Queen’s hand in the days before the Earl of Leicester. She had shown him every favour and he had exploited that favour to the full, making himself extremely unpopular while he was about it. But the Queen did not marry him and he had retired from Court, permanently unmarried but not chaste.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page38"
    }
  }, [_vm._v("‘Did your aunt never tell you about her brother?’ Adorna said. ‘By all accounts your father was a remarkable man. In the Queen’s Secret Service, a scholar, a fine handsome man. Women adored him, and he must have loved your mother and you very much to have wanted you to inherit his entire wealth. He doesn’t sound to me like the kind of man who would want his daughter to hide herself away when ")]), _c('a', {
    attrs: {
      "id": "page39"
    }
  }, [_vm._v("she has the chance to meet people. My mother and father will be here, remember. We’ll take care of you.’")])]), _c('a', {
    attrs: {
      "id": "page39"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Hester, who had been gazing at her hands until now, sighed and stared out of the window. ‘Yes…but…’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘But what?’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Well, you’re so used to it. You know what to say, and you’re so beautiful, and fashionable…and…’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Nonsense! Some of the most fashionable ladies are not beauties, and some beauties are dowdy. Everyone has at least one good feature, and you have several, Hester.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘I do?’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Of course you do. The secret is to make the most of them. Would you like me to help? I can, if you’ll allow it. Maybelle and I can do your hair, and we can find something a little prettier to wear?’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘In black?’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘In black, but more flattering. Yes?’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("At last a smile hovered and broke through. ‘All right. And will you tell me what to say, too?’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Ah, now that,’ Adorna said, ‘may take a little longer, but I can certainly try. The first thing to do is to smile.’")]), _vm._v(" "), _c('p', {
    staticClass: "spaceBreak",
    staticStyle: {
      "text-indent": "0%"
    }
  })]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page39"
    }
  }, [_vm._v("By the time Sir Thomas returned to Sheen House in mid-afternoon, the transformation had begun and the outmoded mousy young lady who had been greeted by Lady Pickering was not quite the same one who curtsied gracefully to the master of the house, though the effort of it robbed her of words. Between them, Adorna and Maybelle had worked wonders. The ")]), _c('a', {
    attrs: {
      "id": "page40"
    }
  }, [_vm._v("hair had now been washed, burnished and arranged into a small jewelled cap that sat on the back of her head like a ripe hazelnut. Hester’s straggly eyebrows had been plucked to form two slim arches, and her faint eyelashes had been darkened with a mixture of soot and saliva, which seemed to work very well. Even those few measures had been enough to convert an ordinary face into a most comely one, but Hester’s greatest assets were her teeth. Once she began to show their dazzling whiteness, there was no reason why she should not smile more often, Adorna told her.")])]), _c('a', {
    attrs: {
      "id": "page40"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Under the loose gown, she was found to be as shapely as most other young women, if somewhat gauche, not knowing what to do with her hands. Or her head, for that matter. But when she tried on Adorna’s black taffeta half-gown with the slashed sleeves and the blackwork partlet, then the new Hester began to emerge.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Teaching her how to move with confidence did not produce such instant results, for there were years of awkwardness and tensions to remove, nervous habits and self-conscious fumblings to eradicate which could not even be mentioned for fear of making them worse. So Adorna advised her to listen rather than to talk. ‘It’s easy enough,’ she said. ‘Men will talk about themselves until the moon turns blue and then some more. You’ll only have to nod and they’ll never notice you haven’t said a word. You can’t fail. They’re all the same. Just smile at them, and they’ll do the rest.’")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page40"
    }
  }, [_vm._v("Hester did not recognise the cynicism, never having found a pressing need to express herself on any par")]), _c('a', {
    attrs: {
      "id": "page41"
    }
  }, [_vm._v("ticular subject, so the advice was well within her capabilities. She had noticed the palace wall beyond the Pickerings’ garden and wanted to know if that was where Sir Thomas worked.")])]), _c('a', {
    attrs: {
      "id": "page41"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘No,’ Adorna told her, ‘my father’s offices and workrooms are round the back, not far from the tennis court and bowling alley. That wall is the Queen’s Gardens. Would you like to see?’ She had noted Hester’s interest in their own.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Predictably, the response was muted. ‘Well…er, might we not be intruding?’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Adorna laughed. ‘Meet somebody? Well, probably the odd courtier or two, or the gardener. Come, let’s show off the new Hester.’ The new Hester followed, dutifully.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The palace itself dominated a large area of the riverside, spreading backwards and upwards in a profusion of towers and turrets that pierced the sky with golden weather-vanes, shining domes, flags and chimneys. The colours of brick and stone mingled joyfully with flashing panes of glass that caught the sun, and the patterns that adorned every surface of the façade never failed to enchant Adorna. But Hester’s eyes were too busy searching for any sign of life to enjoy them. On a rainy day, Adorna told her, one could still walk round the magnificent garden beneath the covered walkway that enclosed all four sides, but Hester was still unsettled. ‘What’s that shouting?’ she whispered, nervously.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘The tennis court, over there at the back. Shall we go and see?’")])]), _c('a', {
    attrs: {
      "id": "page42"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Er…there’ll be people.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘They’ll be far too busy watching the players to see us.’ Adorna took her arm and drew her gently onwards towards the sound of people and the curious pinging noise that became a hard clattering the nearer they walked.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The tennis court was a roofed building like the one at Hampton Court Palace that the Queen’s father had had built. They entered through an arched doorway into a dim passage where suddenly the clatter and men’s cries became sharper, and Adorna felt the resistance of Hester’s arm as she drew back, already fearing what she might see. Although Adorna could sympathise with her cousin’s dilemma, she saw no point in balking at the first hurdle. She placed Hester in front of her and steered her forwards, smiling to herself at each reluctant step.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The light came from windows high up on the two longest sides; the walls built up high had galleries running along them under sloping roofs upon which the hard balls bounced noisily before hitting the paved floor in the centre. A net stretched across the court, visibly sagging in the middle while four men, stripped down to doublets and hose, whacked at the ball with short-handled racquets. The two women sidled into the gallery where men and women leaned over the barrier to watch the play with shouts of, ‘Well done, sir!’ echoing eerily, laughing at the men’s protests, their shouts of jubilation.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page42"
    }
  }, [_vm._v("They found a space behind the barrier, Adorna nodding silent greetings to a few familiar faces, feeling ")]), _c('a', {
    attrs: {
      "id": "page43"
    }
  }, [_vm._v("Hester flinch occasionally as the ball hit the wooden roof overhead and rolled down again. It was only when she gave her full attention to the players that Adorna realized she was within an arm’s length of Sir Nicholas Rayne whose aggressive strokes at the leather ball were causing the marker to call out scores in his favour, though she could not begin to fathom out why.")])]), _c('a', {
    attrs: {
      "id": "page43"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Almost imperceptibly, she drew back, wishing she had not come, yet fascinated by his strength and agility, his amazing reach that scooped the ball up from the most impossible places, his quickness and accuracy. At one point, as the players changed ends, Sir Nicholas was one of those who pulled off their doublets, undoing the points of their white linen shirts. Rolling up their sleeves, they showed muscular forearms, at which Hester was obviously disturbed. ‘Should we go, Adorna?’ she whispered.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The name was caught inside a moment of silence, and Sir Nicholas turned, stared, and deliberately came to the barrier where they stood. He rested his hands just beyond Adorna’s. ‘The Mistresses Pickering. Welcome to Richmond, mistress,’ he said to Hester. His appraisal, Adorna thought, must have been practised on many a likely-looking horse, though thankfully Hester would not realise it.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("But his narrow-eyed survey of Adorna was of a more challenging variety, and his personal greeting to her was no more than, ‘Enjoy the game, mistress,’ which she was quite sure did not mean what Hester thought it meant.")])]), _c('a', {
    attrs: {
      "id": "page44"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She was given no time to find a reply, for he walked quickly away, swinging his racquet, while she was torn between making a quick and dignified exit or staying, hoping to put him off.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("It was Hester’s astonishing response to the greeting, predictably delayed by nervousness, that decided the course of action. ‘Thank you, Sir Nicholas,’ she said to his retreating back.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘What?’ Adorna whispered, staring at her guest. ‘You "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("know")]), _vm._v(" him?’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Hester nodded. ‘Uncle Samuel and Aunt Sarah often invited him to Bishops Standing before he left to join the Earl of Leicester’s household. I’ve not seen him for a year or more. He’s always so polite, but I never know what to say to him.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("For someone who didn’t know what to say, that was the most Hester had said since her arrival. Which, Adorna thought, meant either that Sir Nicholas was the cause of some interest within the timid little heart or that her own efforts were already bearing fruit. Unlikely, after such a short time. ‘Did he visit often?’ she probed, watching him.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Quite often. He and Uncle Samuel used to play chess together, and hunted, and talked about horses.’")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page44"
    }
  }, [_vm._v("Adorna was silenced, overtaken by the combined thudding in her chest and the crash of the ball against the wall. Had he pretended not to know Cousin Hester? Or had he simply not pretended anything? "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("I look forward to meeting Cousin Hester. Is she…?")]), _vm._v(" Of course, it had not occurred to her to discover any previous acquaintance. So what had been the true purpose ")]), _c('a', {
    attrs: {
      "id": "page45"
    }
  }, [_vm._v("of his visit to Sir William Pickering’s sister’s home? Chess? Horses? ‘Is his home near them?’ she whispered.")])]), _c('a', {
    attrs: {
      "id": "page45"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Hester’s reply came with an expression that suggested Adorna ought to have known the answer to that. ‘His father is Lord Elyot,’ she said. ‘He "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("owns")]), _vm._v(" Bishops Standing.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The astonishment showing so clearly in Adorna’s lovely eyes was caught at that moment by the player at the far end of the court whose mind was not entirely on the game. His keen eyes levelled at hers like a hunter stalking a doe, while his partner yelled at him to attend.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Chase two!’ the marker called.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘No. Chase one!’ Sir Nicholas said to himself as he sent the ball crashing across the court. The next time he had chance to look, the two Pickering ladies had disappeared.")]), _vm._v(" "), _c('p', {
    staticClass: "spaceBreak",
    staticStyle: {
      "text-indent": "0%"
    }
  })]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page45"
    }
  }, [_vm._v("The full impact of what was happening to her began to take effect at the end of that day, by which time Adorna was too confused to sleep. She and Hester had strolled back to Sheen House, diverting their steps through the friary paradise especially to examine the overgrown roses, the heavily budding lilies, the rue and lady’s bedstraw that symbolised the Virgin Mary to whom the garden had probably been dedicated. It was a magical place where, even now, the outlines of the beds could still be seen, providing Hester with a topic for suppertime when Lady Marion asked them where they’d been. It saved Adorna herself from hav")]), _c('a', {
    attrs: {
      "id": "page46"
    }
  }, [_vm._v("ing to reply, her mind being far away on another journey.")])]), _c('a', {
    attrs: {
      "id": "page46"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("As the summer evening drew to a close, she made an excuse to be alone, to walk along the raised pathways to the banqueting house to see that the doors and windows were closed. There was a moon, silvering the pathways and the orchard below, outlining the derelict friary and staring through the glassless east window, lighting the high palace wall. She stared out across the paradise where she had walked earlier, frowning as she caught a movement beyond the shadows. A man passed through the garden door from the palace, leaving it slightly ajar, picking his way carefully across the space to stand under a gnarled pear tree, his broad shoulders well inside the low branches. There was no mistaking the shape of him, the long legs, the easy movement, the carriage of his head. Sir Nicholas Rayne. She was quite sure of it.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page46"
    }
  }, [_vm._v("He had waited no more than two minutes when another figure came through the door, a woman, looking about her hesitantly. Sir Nicholas made no move to show himself, no rush to greet her or sudden urge to embrace. The woman searched awhile and then saw him, but still there was no laughter stifled by kisses but only a slow advance and the joining of hands indicating, Adorna thought, either a first meeting or a last one. The two stood together talking, his head bent to hers, her hand occasionally touching his chest, her finger once upon his mouth, briefly. The watcher in the banqueting house placed a hand upon her own breast to still the thumping inside, to quell the first ")]), _c('a', {
    attrs: {
      "id": "page47"
    }
  }, [_vm._v("awful, sour, bitter, agonising pangs of jealousy so foreign to her that she did not recognise them as such. She thought it might be guilt, or something akin to it, telling herself that the man and his woman mattered nothing to her. Less than nothing.")])]), _c('a', {
    attrs: {
      "id": "page47"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Do you have a lady, Sir Nicholas?")])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("No, sir. Not yet.")])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("What was this, then? An attempt to acquire one, or to get rid of one? He was a flirt. He was already welcomed by Hester’s foster-parents, no doubt as a potential suitor for their niece. There was surely no other good reason for them to encourage his visits, for they had no other family. What did it matter to her, anyway?")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The couple was moving apart. The lady was preparing to leave, stretching the last touch of their hands to breaking point. She was weeping. Quickly, he took a stride towards her, reaching out for her shoulders and pulling her with some force towards his bending head. His kiss was short and not gentle, ending with a quick release and a faint cry from her that reached Adorna, wrenching at her heart. She clung to the wall, watching as the woman picked up her skirts and ran to the door, leaving it open behind her.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Sick and dizzy from the impact of a kiss that had not been for her, Adorna stood rooted to the spot, staring at the back of the man she had tried to keep away with her coldness, willing him to turn and come to her here, in the soft shadowy night. He did not move.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page47"
    }
  }, [_vm._v("A call came to her from the house, her father’s call, ")]), _c('a', {
    attrs: {
      "id": "page48"
    }
  }, [_vm._v("loud and unmistakably for her. ‘Adorna! Come in now! It’s getting late, Adorna!’")])]), _c('a', {
    attrs: {
      "id": "page48"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She must answer, or he’d come looking for her. ‘Yes, Father.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("As she knew he would, Sir Nicholas turned towards the high wall behind him where the banqueting house was built into one corner. She could not leave without him seeing, and her loose blonde hair would show him her exact location. Reluctantly, she closed the double doors with a snap and locked them noisily behind her, tossing her bright hair into the moonlight. If she must reveal herself, then she would do it with aplomb. She did not look below her as she went to meet her father. ‘Coming!’ she called, merrily.")]), _vm._v(" "), _c('p', {
    staticClass: "spaceBreak",
    staticStyle: {
      "text-indent": "0%"
    }
  })]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page48"
    }
  }, [_vm._v("The reflection in the polished brass mirror kept up a steady and silent conversation with the blue-grey eyes, and the candle flame bent in the light breeze from the window, barely shedding any light on the messages of confusion and soul-searching that refused to untangle. What had now become clear to Adorna, after her reaction to the secret tryst in the garden, was that she had blundered in the wrong direction by her attempts to make Hester more attractive. Even to herself, she could hardly pretend that she had done it for Hester’s own sake alone, for at the back of her mind had been the possibility that a young and personable lady with a fortune would surely be of more interest to the man who had behaved with such familiarity towards herself. Then, it had seemed imperative that ")]), _c('a', {
    attrs: {
      "id": "page49"
    }
  }, [_vm._v("a way be found to get rid of him or to keep him at a more manageable distance, at least.")])]), _c('a', {
    attrs: {
      "id": "page49"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("But now there had developed within her deepest self a reluctance to exclude this man quite as forcibly as she had been doing, especially now that there seemed to be a real chance of him seeing Hester in a new light. Her foster-parents apparently approved of him, and doubtless Hester herself was impressed by his connections. Another more relaxed and enticing meeting between the two might just be enough to do the trick, and she herself would have helped to bring it about.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Yet she could not like the man. He was too aggressively male, too experienced for her, probably promiscuous, too presumptuous. And rude. And what was he doing speaking so pertly to her when there "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("was")]), _vm._v(" another woman, in spite of his denials? No doubt he had a long line of mistresses somewhere, all of whom he would deny whenever it suited him. Yes, let him make an offer for Hester, since she had come into her fortune. A man like him would appreciate more wealth, rather than the Master of Revels’ daughter.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page49"
    }
  }, [_vm._v("She lifted the sleeve of her chemise to look once more for the imprint of his fingers on her upper arms. There they were, like a row of shadowy blackberry stains. She caressed them, wondering which part of her he had seen yesterday that the other three men had not. Slowly, she slipped her chemise down to her waist and stood, holding herself sideways to the mirror and raising her arms to enclose him, feeling his imaginary grip upon her shoulders, the hard dizzying kiss upon ")]), _c('a', {
    attrs: {
      "id": "page50"
    }
  }, [_vm._v("her mouth. How would it feel? Something deep inside her belly began to quiver and melt.")])]), _c('a', {
    attrs: {
      "id": "page50"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Guiltily, she folded her arms across herself and tiptoed over the creaky floorboards to her bed where she stretched, aching, seeing him again in the moonlit paradise as he turned to look. No, this could not be what they called falling in love; this was confusing and painful; there was nothing in it to make her happy. In the darkness behind her wide-open eyes she watched him at tennis, saw his appraisal of Hester’s new image, saw his hands on her mare’s flanks, his control of his own great mount. His bold words and stare had stirred her to anger and excitement as no other man had done. But no, of course, this was not love. How could it be? She was right; this was not the man for her. Let Hester take the field.")])])]), _c('a', {
    attrs: {
      "id": "page50"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page50"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8e50874a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781459237148_ch02.vue
// module id = 78
// module chunks = 0